import { Popup } from "./popup";

export class ExternalLinkHandler {
    constructor(options = {}) {
        this._externalLinkClass = options.bindTo;
        this._popup = Popup.setup({
            selector: options.popupTarget,
            dismiss: options.dismissTarget
        });
        this._externalLinkTxtEl = jQuery(options.externalLinkTxtEl, this._popup.GetElement());
        this._externalLinkUrl = this._externalLinkTxtEl.text();
        this.bindClick();
        this.bindConfirmClick(options.confirmBtnTarget);
    }

    static setup(options = {}) {
        new ExternalLinkHandler(options)
    }

    bindClick() {
        jQuery(document).on('click', this._externalLinkClass, (event) => {
            const el = event.currentTarget;
            const href = jQuery(el).attr('href');
            if (typeof (href) != 'undefined' && href !== null) {
                event.preventDefault();
                this.updateExternalUrl(href);
                this._popup.Show();
                return false
            }
        })
    }

    bindConfirmClick(target) {
        const confirmBtn = jQuery(target, this._popup.GetElement());
        confirmBtn.on('click', () => {
            window.open(this._externalLinkUrl, "_blank");
            this._popup.Hide();
        });
    }

    updateExternalUrl(txt) {
        this._externalLinkUrl = txt;
        this._externalLinkTxtEl.text(txt);
    }

}